// extracted by mini-css-extract-plugin
export var measureBox = "_af-0";